import { Component, OnInit } from '@angular/core';
//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

import { greviencemodel } from '../../models/grevience/grevience.model';
import { ComplainTitleModel } from '../../models/complainTitle/complainTitle.model';
import { IMyDpOptions } from 'mydatepicker';
import { ActivatedRoute } from '@angular/router';
// import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
	selector: 'app-grevience-manage',
	templateUrl: './grevienceMangement.component.html',
	styleUrls: ['./grevienceMangement.component.css']
})
export class grevienceMangementComponent implements OnInit {
	//variable deceleration
	public errorMsg: string = "";
	public successMsg: string = "";
	public sessionData: any;
	public allGrevienceData: any = [];
	public allCategoryData: any = [];
	public allSubData: any = [];
	public greviencemodel: greviencemodel = new greviencemodel;
	public selectedComplainTitle: ComplainTitleModel = new ComplainTitleModel();
	public selectedComplainCatagory: ComplainTitleModel = new ComplainTitleModel();
	public selectedSubComplainCatagory: ComplainTitleModel = new ComplainTitleModel();
	public complainTitleList: any = [];
	public isHideConsumerOtp: boolean = true;
	public serviceOn: boolean = false;
	public catagoryList: any = [];
	public subCatagoryList: any = [];
	public popupopen: boolean = false;
	public viewpopupopen: boolean = false;
	public viewStatus: string = "";
	public viewDate: any = "";
	public viewDocket: any = "";
	public viewCat: any = "";
	public viewSubCat: any = "";
	public viewDetails: string = "";
	public consumerNumber: number;
	public consumerNo: string;
	public isDisabledComplain: boolean = true;
	public otp: String = "";
	public isHideGrivance: boolean = true;
	public isHideConsumer: boolean = true;
	public isHideEmail: boolean = true;
	public showEmailOtp: boolean = true;
	public isHideMobile: boolean = true;
	public hideMobileOtp: boolean = true;
	public isHideChooseOption: boolean = false;
	public isHideBack: boolean = true;
	public isHideConsumerNo: boolean = false;
	public emailOTP: boolean;
	public mobileOTP: any;
	public result: any;
	public mobileResult: any;
	public consumerResult: any;
	public isTeccompletedID: any;
	public isTecOutstandingID: any;
	public isComOutstandingID: any;
	public isComcompletedID: any;
	public isHideCreateNew: boolean = true;
	public isValidated: boolean = true;
	public isHideHistory: boolean = true;
	public isHideConsumerOtpp: boolean = false;
	public consumerId: any;
	public password: any;
	public mobileNumber: any;

	public myDatePickerOptions: IMyDpOptions = {
		dateFormat: 'dd/mm/yyyy',
		disableUntil: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1 }
	};

	constructor(public http: HttpTestService, 
				public session: sessionServices,
				private actvRoute: ActivatedRoute) { }

	ngOnInit() {
		this.serviceOn = true;
		this.getSession();
		//this.getAllGrevience();
		this.getCategory();
		this.getComplainTitle();

		if (this.sessionData.sessionStarted == "true") {

			this.isHideChooseOption = true;
			this.consumerId = this.sessionData.consumerId;
			this.password = this.sessionData.credChange;
			this.getGrevienceByConsumerId(this.sessionData.consumerId);
			this.withLoginGrivanceDetails(this.consumerId);

			//----create data for showing in popup------/
			this.greviencemodel.mobileNo = this.sessionData.sessionMobile;
			this.greviencemodel.name1 = this.sessionData.sessionConName;
			this.greviencemodel.emailId = this.sessionData.sessionEmail;
			this.greviencemodel.consumerNumber = this.sessionData.consumerId ;
			//-----------create data for showing in popup----------------//
			
		} else {
			this.isHideChooseOption = false;
		}
		this.serviceOn = false;
		//-------Code snippet for chatbot purpose only---------//		
		let fromChatConsmrId = this.actvRoute.snapshot.paramMap.get('consumerID') ;
		if(fromChatConsmrId) this.getGrevienceByConsumerId(fromChatConsmrId);
		//------------------------------------//
	}
	withLoginGrivanceDetails(consumerId) {
		var self = this;
		self.http.getGrivanceData(consumerId).subscribe(

			(data) => {
				self.allGrevienceData = data;
				if (self.allGrevienceData.length > 0) {
					this.isHideGrivance = false;
					this.isHideChooseOption = true;
					this.isHideEmail = true;
					this.showEmailOtp = true;
					this.isHideMobile = true;
					this.hideMobileOtp = true;
				}

				if (self.allGrevienceData.length === 1)
					this.isDisabledComplain = false;
				else {
					if (self.allGrevienceData.find(ob => ob['status'] === 'Notification completed'))
						this.isDisabledComplain = false;
					else
						this.isDisabledComplain = true;
				}
				this.isValidated = false;
				this.checkCatagory();
				if (self.allGrevienceData.length >= 1) {
					if (self.allGrevienceData[0].status === "List Empty") {
						self.errorMsg = "Sorry! There is no record";
						this.isHideConsumer = true;
						this.isHideChooseOption = true;
						this.isHideCreateNew = true;
						//this.isHideGrivance = false;
						this.isDisabledComplain = false;
						this.isHideGrivance = true;
						this.isHideChooseOption = true;
						this.isHideEmail = true;
						this.showEmailOtp = true;
						this.isHideMobile = true;
						this.hideMobileOtp = true;
						this.isHideCreateNew = false;
					}

				} else {
					this.isHideGrivance = true;
					this.isHideCreateNew = false;
				}

				// if (self.allGrevienceData.length > 0) {
				// 	this.isHideGrivance = false;
				// 	this.isHideChooseOption = true;
				// 	this.isHideEmail = true;
				// 	this.showEmailOtp = true;
				// 	this.isHideMobile = true;
				// 	this.hideMobileOtp = true;
				// } 
			},
			(error) => {
				
			},

			() => {

			}
		)

	}

	public consumerPostData = {
		"consumerNumber": null,
		"password": null,
		"emailId": null,
		"emailOTP": null,
		"mobileNumber": null,
		"mobileOTP": null,
		"otp": null,
		"consumerOTP": null
	}

	getComplainTitle = function () {
		var self = this;
		self.http.getComplainTile().subscribe(

			(data) => {
				self.complainTitleList = data;
				
			},
			(error) => {
				
			},

			() => {

			}
		)
	}

	onSelect(complainTitleId) {
		var self = this;
		self.http.getCatagoryList(complainTitleId).subscribe(
			(data) => {
				self.catagoryList = data;
			},
			(error) => {
				
			},

			() => {

			}
		)
	}

	proceedEmail() {
		var self = this;
		self.serviceOn = true;
		self.errorMsg = '';
		this.isHideEmail = true;
		this.showEmailOtp = false;
		self.http.getOTPbyEmail(self.greviencemodel.emailId).subscribe(
			(data) => {
				self.emailOTP = data;
				if (self.emailOTP) {
					this.isHideEmail = true;
					this.showEmailOtp = false;
					
				} else {
					this.isHideEmail = false;
					this.showEmailOtp = true;
					self.errorMsg = "The provided Email does not exist";
				}
				
			},
			(error) => {
				
			},

			() => {
				self.serviceOn = false;
			}

		)

	}

	proceedMobile() {
		var self = this;
		self.errorMsg = '';
		self.serviceOn = true;
		this.hideMobileOtp = false;
		this.isHideMobile = true;
		let mobileNo = "+91" + self.greviencemodel.mobileNumber;

		self.http.getOTPbyMobile(mobileNo).subscribe(
			(data) => {
				self.mobileOTP = data;
				if (self.mobileOTP) {
					self.hideMobileOtp = false;
					self.isHideMobile = true;

				} else {
					self.hideMobileOtp = true;
					self.isHideMobile = false;
					self.errorMsg = "The provided mobile does not exist";
				}
			},
			(error) => {
				// self.errorMsg = error;
			},

			() => {
				self.serviceOn = false;
			}

		)

	}

	back() {
		this.errorMsg = "";
		this.greviencemodel.selectedOption = null;
		this.isHideChooseOption = false;
		this.isHideConsumer = true;
		this.isHideEmail = true;
		this.isHideMobile = true;
	}

	backForEmailOtp() {
		this.errorMsg = "";
		this.greviencemodel.emailId = "";
		this.showEmailOtp = true;
		this.isHideEmail = false;

	}

	onSelectGrivance(selectedID) {
		if (selectedID == 1) {
			this.isHideConsumer = false;
			this.isHideEmail = true;
			this.hideMobileOtp = true;
			this.showEmailOtp = true;
			this.isHideMobile = true;
			this.isHideBack = false;
			this.isHideChooseOption = true;
			this.isHideConsumerNo = false;
			this.isHideConsumerOtp = true;
		} else if (selectedID == 2) {
			this.isHideMobile = true;
			this.isHideEmail = false;
			this.isHideConsumer = true;
			this.hideMobileOtp = true;
			this.isHideBack = false;
			this.isHideChooseOption = true;
		} else if (selectedID == 3) {
			this.isHideConsumer = true;
			this.isHideMobile = false;
			this.isHideEmail = true;
			this.hideMobileOtp = true;
			this.isHideChooseOption = true;
			this.isHideBack = false;
		}	
	}

	onSelectCatagory(catID) {
		var self = this;
		self.http.getSubCatagoryList(catID).subscribe(
			(data) => {
				self.subCatagoryList = data;
			},
			(error) => {
				//	self.errorMsg = error;
			},

			() => {

			}
		)
	}

	checkCatagory() {
		for (var i = 0; i < this.allGrevienceData.length; i++) {
			if (this.allGrevienceData[i].grievanceTypeName == "Technical") {
				if (this.allGrevienceData[i].status == "Notification completed") {
					this.isTeccompletedID = 1;
				} else {
					this.isTecOutstandingID = 2;
				}
			} else if (this.allGrevienceData[i].grievanceTypeName == "Commercial") {
				if (this.allGrevienceData[i].status == "Notification completed") {
					this.isComOutstandingID = 3;
				} else {
					this.isComcompletedID = 4;
				}
			}
		}

		if (this.isTeccompletedID == 1 && this.isComOutstandingID == 3) {
			this.isDisabledComplain = false;
		} else if (this.isTeccompletedID == 1 && this.isComcompletedID == 4) {
			this.isDisabledComplain = false;
		} else if (this.isTecOutstandingID == 2 && this.isComOutstandingID == 3) {
			this.isDisabledComplain = false;
		} else if (this.isTecOutstandingID == 2 && this.isComcompletedID == 4) {
			this.isDisabledComplain = true;
		} else {
			this.isDisabledComplain = false;
		}
	}

	consumerLogin() {
		var self = this;
		self.errorMsg = '';
		self.serviceOn = true;
		let consumerDetailsEntity :any = {
			
			"consumerId" : self.greviencemodel.consumerNumber,
			"mobNo" : self.greviencemodel.mobileNo 
		};
		this.consumerNo = self.greviencemodel.consumerNumber;
			this.http.authenticateComplainConsumerNoAndMobile(consumerDetailsEntity).subscribe(
				(data) => {
					self.allGrevienceData = data;
					if (self.allGrevienceData.responseMessage === "success") {
						self.successMsg = self.allGrevienceData.responseMessage ;
						//----create data for showing in popup------/
						if(self.allGrevienceData.responseObj != null ){

							this.greviencemodel.mobileNo = self.allGrevienceData.responseObj.mobile;
							this.mobileNumber = self.allGrevienceData.responseObj.mobile;
							this.greviencemodel.name1 = self.allGrevienceData.responseObj.name;
							this.greviencemodel.emailId = self.allGrevienceData.responseObj.emailid;
							this.greviencemodel.consumerNumber = this.consumerNo ;
						}
						//----End of create data for showing in popup------/
							this.checkCatagory();
							//this.getAllGrevience();
							this.getCategory();
							this.getComplainTitle();
							this.isHideConsumerOtp = true;
							this.isHideConsumer = true;
							this.isHideGrivance = false;
							this.isHideChooseOption = true;
							this.getGrevienceByConsumerId(self.greviencemodel.consumerNumber);
							//this.isHideConsumerNo = true;
							//this.isHideConsumerOtp = false;	
					} else if(self.allGrevienceData.responseMessage === "fail") {
						self.errorMsg = "Sorry! We can't proceed for invalid information.";
						self.serviceOn = false;
						//this.isHideConsumerOtp = true;
						//this.isHideConsumerNo = false;
					} else if(self.allGrevienceData.responseMessage === "GAYACONSUMERID"){
						self.errorMsg = "Service is not available for this Gaya Consumer";
						self.serviceOn = false;
						//this.isHideConsumerOtp = true;
						//this.isHideConsumerNo = false;
					}
				},(error) => {
					self.errorMsg = "Sorry! Consumer No Or Mobile is not correct";
				},() => {
					//this.blockUI.stop();
					self.serviceOn = false;});						
	}


	// consumerLogin() {
	// 	var self = this;
	// 	//	var consumerNoWithPass = self.greviencemodel.consumerNumber+'^'+self.greviencemodel.password;
	// 	self.consumerPostData.consumerNumber = self.greviencemodel.consumerNumber;
	// 	//self.consumerPostData.password = self.greviencemodel.password;

	// 	self.http.validateConsumerNoWithPass(self.consumerPostData)
	// 		.subscribe(
	// 			(data: greviencemodel) => {
	// 				self.allGrevienceData = data;
	// 				this.checkCatagory();
	// 			// 	if(self.allGrevienceData[1].catagoryType == 1){
	// 			// 		this.isDisabledComplain = false;
	// 			//    }else if(self.allGrevienceData[1].catagoryType == 2){
	// 			// 	   this.isDisabledComplain = false;
	// 			//    }else if(self.allGrevienceData[1].catagoryType == 3){
	// 			// 	   this.isDisabledComplain = true;
	// 			//    }else if(self.allGrevienceData[1].catagoryType == 4){
	// 			// 	   this.isDisabledComplain = false;
	// 			//    }

	// 			if (self.allGrevienceData[0].status === "Password Mismatched") {
	// 					// alert("ok1");
	// 					self.errorMsg = "Sorry! Consumer No Or Password is not correct";
	// 					this.isHideConsumer = false;
	// 					this.isHideChooseOption = true;
	// 					this.isHideGrivance = true;

	// 				}
	// 				else if (self.allGrevienceData[0].status === "List Empty") {
	// 					//alert("ok2");
	// 					self.errorMsg = "Sorry! There is no record";
	// 					this.isHideConsumer = true;
	// 					this.isHideChooseOption = true;
	// 					this.isHideCreateNew = false;
	// 					//this.isHideGrivance = false;
	// 					this.isDisabledComplain = false;
	// 				}

	// 				else if (self.allGrevienceData[0].status !== "Password Mismatched" && self.allGrevienceData[0].status !== "List Empty") {
	// 					//	alert("ok3");
	// 					self.allGrevienceData = data;
	// 					this.showEmailOtp = true;
	// 					this.isHideConsumer = true;
	// 					this.isHideGrivance = false;
	// 					if (self.allGrevienceData[0].status === "Notification completed") {
	// 						this.isDisabledComplain = false;
	// 					}
	// 				}

	// 			},
	// 			(error) => {
	// 				self.errorMsg = "Sorry! Consumer No Or Password is not correct";
	// 			},
	// 			() => { }
	// 		);

	// }

	validateConsumerOtp() {
		var self = this;
		self.errorMsg = '';
		self.serviceOn = true;
		self.consumerPostData.consumerNumber = self.greviencemodel.consumerNumber;
		self.consumerPostData.consumerOTP = self.greviencemodel.consumerOTP;
		self.http.validateConsumerNoWithOTP(this.consumerPostData)
			.subscribe(
				(data) => {
					self.allGrevienceData = data;

					if (self.allGrevienceData.length === 1)
						this.isDisabledComplain = false;
					else {
						if (self.allGrevienceData.find(ob => ob['status'] === 'Notification completed'))
							this.isDisabledComplain = false;
						else
							this.isDisabledComplain = true;
					}
					this.isValidated = false;
					this.checkCatagory();
					if (self.allGrevienceData.length >= 1) {
						if (self.allGrevienceData[0].status === "List Empty") {
							//alert("ok2");
							self.errorMsg = "Sorry! There is no record";
							this.isHideConsumer = true;
							this.isHideChooseOption = true;
							this.isHideCreateNew = false;
							//this.isHideGrivance = false;
							this.isDisabledComplain = false;
						}
						if (self.allGrevienceData[0].status === "OTP Mismatched") {
							//alert("ok1");
							self.errorMsg = "Sorry! Invalid OTP";
							this.isHideConsumerOtp = false;
							this.isHideConsumer = true;
							this.isHideChooseOption = true;
							this.isHideGrivance = true;
							this.isValidated = true;
							this.isHideConsumer = false;
						}

						else if (self.allGrevienceData[0].status !== "OTP Mismatched" && self.allGrevienceData[0].status !== "List Empty") {
							self.allGrevienceData = data;
							this.isHideConsumerOtp = true;
							this.isHideConsumer = true;
							this.isHideGrivance = false;
							this.checkCatagory();
							this.isHideChooseOption = true;

						}

					} else {
						self.errorMsg = "Sorry! Entered OTP is not valid !";
					}
				},
				(error) => {
					self.errorMsg = "Sorry! Entered OTP is not valid !";
				},
				() => {
					self.serviceOn = false;
				}
			);
	}

	validateEmailOtp() {
		var self = this;
		self.errorMsg = '';
		self.serviceOn = true;
		self.consumerPostData.emailId = self.greviencemodel.emailId;
		self.consumerPostData.emailOTP = self.greviencemodel.emailOTP;
		//alert(emailWithOTP);
		self.http.validateEmailByOTP(this.consumerPostData)
			.subscribe(
				(data: any) => {
					self.allGrevienceData = data;

					if (self.allGrevienceData.length === 1)
						this.isDisabledComplain = false;
					else {
						if (self.allGrevienceData.find(ob => ob['status'] === 'Notification completed'))
							this.isDisabledComplain = false;
						else
							this.isDisabledComplain = true;
					}
					this.isValidated = false;
					if (self.allGrevienceData[0].status === "OTP Mismatched") {
						//alert("ok1");
						self.errorMsg = "Sorry! Invalid OTP";
						this.isHideConsumer = true;
						this.isHideChooseOption = true;
						this.isHideGrivance = true;
						this.showEmailOtp = false;

					}
					else if (self.allGrevienceData[0].status === "List Empty") {
						self.errorMsg = "Sorry! There is no record";
						this.isHideConsumer = true;
						this.isHideChooseOption = true;
						this.isHideEmail = true;
						this.showEmailOtp = true;
						this.isDisabledComplain = false;
						this.isHideCreateNew = false;


					}

					else if (self.allGrevienceData[0].status !== "OTP Mismatched" && self.allGrevienceData[0].status !== "List Empty") {
						self.allGrevienceData = data;
						this.showEmailOtp = true;
						this.hideMobileOtp = true;
						this.isHideConsumer = true;
						this.isHideGrivance = false;
						this.checkCatagory();
						this.isHideChooseOption = true;
						this.hideMobileOtp = true;
						this.isHideEmail = true;
						
					}

				},
				(error) => {
					this.showEmailOtp = true;
					this.isHideHistory = true;
					self.errorMsg = "Sorry! There is no record";
				},
				() => {
					self.serviceOn = false;
				}
			);
	}


	backForMobile() {
		//	alert("ok")
		this.errorMsg = "";
		this.greviencemodel.mobileNumber = null;
		this.isHideMobile = false;
		this.hideMobileOtp = true;
	}

	validateMobileOtp() {
		var self = this;
		self.errorMsg = '';
		self.serviceOn = true;
		self.consumerPostData.mobileNumber = "+91" + self.greviencemodel.mobileNumber;
		self.consumerPostData.mobileOTP = self.greviencemodel.mobileOtp;

		self.http.validateMobileByOTP(this.consumerPostData).subscribe(
			(data: any) => {
				self.allGrevienceData = data;
				// 	if(self.allGrevienceData[1].catagoryType == 1){
				// 		this.isDisabledComplain = false;
				//    }else if(self.allGrevienceData[1].catagoryType == 2){
				// 	   this.isDisabledComplain = false;
				//    }else if(self.allGrevienceData[1].catagoryType == 3){
				// 	   this.isDisabledComplain = true;
				//    }else if(self.allGrevienceData[1].catagoryType == 4){
				// 	   this.isDisabledComplain = false;
				//    }

				if (self.allGrevienceData[0].status === "OTP Mismatched") {
					self.errorMsg = "Sorry!In Valid OTP";
					this.isHideConsumer = true;
					this.isHideChooseOption = true;
					this.isHideGrivance = true;
					this.hideMobileOtp = false;
				}
				else if (self.allGrevienceData[0].status === "List Empty") {
					self.errorMsg = "Sorry! There is no record";
					this.isHideConsumer = true;
					this.isHideChooseOption = true;
					this.isHideGrivance = true;
					this.isDisabledComplain = false;
					this.hideMobileOtp = true;
					this.isHideCreateNew = false;


				}

				else if (self.allGrevienceData[0].status !== "OTP Mismatched" && self.allGrevienceData[0].status !== "List Empty") {
					self.allGrevienceData = data;
					this.showEmailOtp = true;
					this.isHideConsumer = true;
					this.hideMobileOtp = true;
					this.isHideGrivance = false;
					this.hideMobileOtp = true;
					this.checkCatagory();
				}

			},

			(error) => {
				self.errorMsg = "Sorry!Invalid OTP";
			},
			() => {
				self.serviceOn = false;
			}
		);
	}

	
	getSession = function () {
		this.sessionData = this.session.getSessionDetails();
		this.consumerNumber = this.sessionData.sessionId;
	}


	getAllGrevience = function () {
		//	alert("Grivance Data");
		var self = this;
		self.http.getGrevienceDetails()
			.subscribe(
				(data: greviencemodel) => {
					self.allGrevienceData = data;

				},
				(error) => {
					//	self.errorMsg = error;
					self.allGrevienceData = [];
				},
				() => { }
			);
	}
	getGrevienceByConsumerId(consumerNumber){
		this.http.getGrevienceDetailsByConsumerNo(consumerNumber)
		.subscribe(
			(data: greviencemodel) => {
				this.allGrevienceData = data;
			},
			(error) => {
					this.errorMsg = error;
				this.allGrevienceData = [];
			},
			() => { }
		);
	}

	changeBradcastList = function (e) {
		var self = this;
		var selectedType = e.target.value;
		if (selectedType == "Gen") {
			self.ViewableBroadcastData = self.GenBroadcastData;
		} else {
			self.ViewableBroadcastData = self.ZonalBroadcastData;
		}

	}

	createGrivance = function () {
		var self = this;
		
		self.errorMsg = "";
		//self.popupopen = false;
		
		self.greviencemodel.grievanceTitleId = self.selectedComplainTitle.titleId;
		self.greviencemodel.grievanceTypeId = self.selectedComplainCatagory.typeId;
		self.greviencemodel.grievanceSubTypeId = self.selectedSubComplainCatagory.subTypeId;
		self.greviencemodel.grievanceNarration = self.greviencemodel.grievanceNarration;
		if (this.sessionData.sessionStarted == "true") {
			self.greviencemodel.consumerNumber = this.sessionData.consumerId;
			self.greviencemodel.mobileNo  = this.sessionData.sessionMobile ;
		} else {
			self.greviencemodel.consumerNumber = this.consumerNo;
		}

		if(self.selectedComplainTitle.titleId != undefined && self.selectedComplainTitle.titleId != null && self.selectedComplainTitle.titleId != "" &&
			self.selectedComplainCatagory.typeId  != undefined && self.selectedComplainCatagory.typeId  != null && self.selectedComplainCatagory.typeId  != "" &&
			self.selectedSubComplainCatagory.subTypeId != undefined && self.selectedSubComplainCatagory.subTypeId != null && self.selectedSubComplainCatagory.subTypeId !="" ){
				
				self.serviceOn = true;
				self.popupopen = false; 
				self.viewpopupopen = false;
				self.isHideGrivance = false;
				self.isHideCreateNew = true;
				//----service call----//
				self.http.postGrievanceDetails(self.greviencemodel).subscribe(
					(data) => {
						self.allGrevienceData = data;
						self.successMsg = "You have successfully Created Grievance.";
						if (self.allGrevienceData.length > 0) {
							this.isHideHistory = false;
						} else {
							this.isHideHistory = true;
						}
						if (self.allGrevienceData.length === 1)
							this.isDisabledComplain = false;
						else {
							if (self.allGrevienceData.find(ob => ob['status'] === 'Notification completed'))
								this.isDisabledComplain = false;
							else
								this.isDisabledComplain = true;
						}
		
						if (self.allGrevienceData.find(ob => ob['status'] === 'same category complain open')) {
							this.errorMsg = "Complain with this same category is already in process";
							self.successMsg = '';
							this.isDisabledComplain = false;
						}
		
						self.allGrevienceData = self.allGrevienceData.filter(x => x.status !== "same category complain open");
					},
					(error) => {
						//self.errorMsg = error;
					},
					() => {
						self.greviencemodel.complainTitle = " ";
						//self.greviencemodel.mobileNo = " ";
						self.serviceOn = true;
		
						self.greviencemodel.grievanceTitleId = "";
						self.greviencemodel.grievanceTypeId = "";
						self.greviencemodel.grievanceSubTypeId = "";
						self.greviencemodel.grievanceNarration = "";
						//self.greviencemodel.consumerNumber = "";
						self.serviceOn = false;
					});
				//-------End of service call----------//

		} else {
			self.errorMsg = "Please fill up the mandatory field."
		}
		/**/
	}

	getCategory = function () {
		var self = this;
		self.http.getGrevienceCats()
			.subscribe(
				(data) => {
					self.allCategoryData = data;
				},
				(error) => {
					//	self.errorMsg = error;
					self.allCategoryData = [];
				},
				() => { }
			);
	}

	getSub = function (e) {
		var self = this;
		self.allSubData = [];
		self.greviencemodel.grevienceSubCat = "";
		var selectedRegion = e.target.value;
		//  if(selectedRegion != ''){
		// 	 self.allSubData = self.allCategoryData[selectedRegion].sub;
		//  }

		self.http.getGrevienceSubCats(selectedRegion)
			.subscribe(
				(data) => {
					self.allCategoryData = data;
				},
				(error) => {
					// self.errorMsg = error;
					self.allCategoryData = [];
				},
				() => { }
			);



	}

	createUserPopupReset = function () {
		var self = this;
		self.greviencemodel.grevienceCat = "";
		self.greviencemodel.grevienceSubCat = "";
		self.greviencemodel.grevienceDetails = "";
		self.viewStatus = "";
		self.viewDate = "";
		self.viewDocket = "";
		self.viewCat = "";
		self.viewSubCat = "";
		self.viewDetails = "";
	}

	openPopup = function () {
		//alert("Ok")
		var self = this;
		self.createUserPopupReset();
		self.popupopen = true;
		self.greviencemodel.mobileNo = this.mobileNumber ;
	}

	closePopup = function () {
		var self = this;
		self.createUserPopupReset();
		self.selectedComplainTitle.titleId = "";
		self.selectedComplainCatagory.typeId = "";
		self.selectedSubComplainCatagory.subTypeId = "";
		self.greviencemodel.grievanceTypeId = null;
		self.greviencemodel.grievanceSubTypeId = " ";
		self.greviencemodel.grievanceNarration = "";
		self.greviencemodel.mobileNo = "";

		self.greviencemodel.consumerNumber = self.consumerNumber;
		self.popupopen = false;
		self.viewpopupopen = false;
	}

	getDetails = function (index) {
		var self = this;
		self.viewStatus = self.allGrevienceData[index].status;
		self.viewDate = self.allGrevienceData[index].date;
		self.viewDocket = self.allGrevienceData[index].docketno;
		self.viewCat = self.allGrevienceData[index].catName;
		self.viewSubCat = self.allGrevienceData[index].subCatName;
		self.viewDetails = self.allGrevienceData[index].msg;
		self.viewpopupopen = true;
	}


}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/grevience/grevienceMangement.component.ts